import React from 'react';
import { useSelector } from 'react-redux';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { useSocioeconomicChartsData } from '../../../../hooks/useSocioeconomicChartsData';
import { colorsPieCharts } from '../../../../shared/constants/colors';
import { GenericChartCard } from '../../../../component/charts/genericChartCard';
import { ErrorState } from './errorState';
import {
  generateTitleAndSource,
  renderLegend,
} from './socioeconomicDemographicCharts';
import nls from '../nls/pt-BR.json';

export const GenderDistribution: React.FC = () => {
  const { errorFetchData } =
    useSelector((state: any) => state.socioeconomicDemographicState) || '';

  const { genderDistributionFormattedData } = useSocioeconomicChartsData();
  return (
    <GenericChartCard
      title={generateTitleAndSource(
        nls.charts.genderDistribution.genderDistribution,
        nls.disclaimers.dataSourceIBGE2010
      )}
    >
      {errorFetchData?.genderDistribution ? (
        <ErrorState />
      ) : (
        <ResponsiveContainer width="100%" height="80%">
          <PieChart width={400} height={400}>
            <Pie
              data={genderDistributionFormattedData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={120}
              labelLine={false}
              fill="#8884d8"
            >
              {genderDistributionFormattedData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colorsPieCharts[index % colorsPieCharts.length]}
                />
              ))}
            </Pie>
            <Legend
              verticalAlign="bottom"
              height={60}
              content={renderLegend(genderDistributionFormattedData)}
            />
          </PieChart>
        </ResponsiveContainer>
      )}
    </GenericChartCard>
  );
};
